import React from "react";
import { BuildingOfficeIcon, UserIcon, XIcon } from "@phosphor-icons/react";
import { Modal } from "react-bootstrap";

import Icon from "components/Icon/Icon";
import LoadingSpinner from "components/PageLoader/Spinner";

import { UserStatusStyles } from "./styled";

const UserStatusModal = ({ show, onClose, loading, users }) => {
  const companyName =
    users?.[0]?.company?.company_name ||
    users?.[0]?.["company.company_name"] ||
    "-";

  const userStatus = users?.[0]?.status === "deactivated";

  return (
    <UserStatusStyles
      show={show}
      onHide={onClose}
      backdrop
      keyboard
      // unmountOnExit
      restoreFocus={false}
      enforceFocus={false}
      scrollable
      className="sidebar-modal"
    >
      <Modal.Header>
        <Modal.Title>{`${userStatus ? "Deactivated" : "Activated"} Users`}</Modal.Title>

        <div className="close-icon-wrapper" onClick={onClose}>
          <Icon component={XIcon} size={24} />
        </div>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <LoadingSpinner
            color="#797979"
            text="Loading Data..."
            fontSize={16}
          />
        ) : (
          <>
            {/* Company */}
            <div className="company-details">
              <div className="user-status">
                <div className="section-label">
                  <Icon
                    component={BuildingOfficeIcon}
                    size={20}
                    color="#797979"
                  />
                  <span>Company</span>
                </div>
                <p className="main-text">{companyName}</p>
              </div>
            </div>

            {/* Users */}
            <div className="users-section">
              <div className="users-title">Users ({users?.length || 0})</div>

              <div className="users-list">
                {users?.map((user) => {
                  const fullName =
                    `${user.first_name || ""} ${user.last_name || ""}`.trim() ||
                    "-";

                  return (
                    <div className="user-card" key={user.id}>
                      <div className="user-icon">
                        <Icon component={UserIcon} size={20} color="#797979" />
                      </div>

                      <div className="user-info">
                        <p className="user-name">{fullName}</p>

                        <p className="user-email">{user.email || "-"}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        )}
      </Modal.Body>
    </UserStatusStyles>
  );
};

export default UserStatusModal;
